// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--DNCYvTGyzS8Sav9p","content":"content--SK_wtItPL8YQRZNm"};